import { css } from "@emotion/react";
import { FC } from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

const containerStyles = css`
  display: inline-block;
  margin-left: 4px;
`;

const positiveStyles = css`
  color: ${withVar(DesignToken.ActionPositiveDefault)};
`;

const negativeStyles = css`
  color: ${withVar(DesignToken.ActionNegativeDefault)};
`;

interface IProps {
  value: number | string;
  isPositive: boolean;
}

export const ChangeLabel: FC<IProps> = ({ value, isPositive }) => (
  <div css={[containerStyles, isPositive ? positiveStyles : negativeStyles]}>
    ({isPositive ? "+" : "-"}
    {value})
  </div>
);
